import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) { setError('Пароль — минимум 6 символов'); return; }
    if (newPassword !== confirmPassword) { setError('Пароли не совпадают'); return; }
    setLoading(true);
    try {
      await api.put('/auth/reset-password', { token, newPassword });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка. Попробуйте запросить ссылку заново.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'linear-gradient(135deg,#0E0B18,#1A0030)',padding:'1rem'}}>
      <div style={{background:'#1A0B2E',border:'1.5px solid rgba(255,255,255,.12)',borderRadius:20,padding:28,maxWidth:360,width:'100%',boxShadow:'0 30px 60px rgba(0,0,0,.6)'}}>
        {done ? (
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:'2.5rem',marginBottom:8}}>✅</div>
            <h3 style={{color:'#fff',fontFamily:'system-ui',fontWeight:700,fontSize:'1.1rem',margin:'0 0 8px'}}>Пароль изменён</h3>
            <p style={{color:'rgba(255,255,255,.5)',fontSize:'.85rem',margin:0}}>Переходим на страницу входа...</p>
          </div>
        ) : (
          <>
            <div style={{textAlign:'center',marginBottom:16}}>
              <div style={{fontSize:'2.5rem',marginBottom:8}}>🔑</div>
              <h3 style={{color:'#fff',fontFamily:'system-ui',fontWeight:700,fontSize:'1.1rem',margin:'0 0 8px'}}>Новый пароль</h3>
              <p style={{color:'rgba(255,255,255,.45)',fontSize:'.85rem',lineHeight:1.65,margin:0}}>
                Придумайте новый пароль для входа в MolShape.
              </p>
            </div>
            <form onSubmit={submit}>
              <input
                type="password"
                placeholder="Новый пароль (мин. 6 символов)"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                style={{width:'100%',padding:'.75rem 1rem',borderRadius:12,border:'1px solid rgba(255,255,255,.15)',background:'rgba(255,255,255,.06)',color:'#fff',fontSize:'.9rem',marginBottom:12,outline:'none',boxSizing:'border-box'}}
              />
              <input
                type="password"
                placeholder="Повторите пароль"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                style={{width:'100%',padding:'.75rem 1rem',borderRadius:12,border:'1px solid rgba(255,255,255,.15)',background:'rgba(255,255,255,.06)',color:'#fff',fontSize:'.9rem',marginBottom:12,outline:'none',boxSizing:'border-box'}}
              />
              {error && (
                <p style={{color:'#EF4444',fontSize:'.8rem',margin:'0 0 12px'}}>{error}</p>
              )}
              <button type="submit" disabled={loading} style={{width:'100%',background:'#C8005A',border:'none',borderRadius:12,padding:'.75rem',color:'#fff',fontWeight:700,fontSize:'.9rem',cursor:'pointer'}}>
                {loading ? 'Сохраняю...' : 'Сохранить пароль'}
              </button>
            </form>
            <div style={{textAlign:'center',marginTop:16}}>
              <Link to="/login" style={{color:'rgba(255,255,255,.35)',fontSize:'.78rem',textDecoration:'none'}}>← Вернуться ко входу</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
